"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAttributeValuesMany = exports.removeAttributeValues = exports.addUniqueMany = exports.addUnique = exports.getAttributeFromValueKey = exports.getAttributePrefix = exports.getValueKey = void 0;
const ramda_1 = require("ramda");
const getValueKey = (attributeLabel, value) => `${attributeLabel}::${value}`;
exports.getValueKey = getValueKey;
const getAttributePrefix = (attributeLabel) => `${attributeLabel}::`;
exports.getAttributePrefix = getAttributePrefix;
const getAttributeFromValueKey = (key) => {
    const sepIdx = key.indexOf('::');
    return sepIdx === -1 ? null : key.slice(0, sepIdx);
};
exports.getAttributeFromValueKey = getAttributeFromValueKey;
const addUnique = (items, item) => (items.includes(item) ? items : [...items, item]);
exports.addUnique = addUnique;
const addUniqueMany = (items, newItems) => (0, ramda_1.uniq)([...items, ...newItems]);
exports.addUniqueMany = addUniqueMany;
const removeAttributeValues = (items, attributeLabel) => {
    const prefix = (0, exports.getAttributePrefix)(attributeLabel);
    return items.filter((item) => !item.startsWith(prefix));
};
exports.removeAttributeValues = removeAttributeValues;
const removeAttributeValuesMany = (items, attributeLabels) => {
    if (attributeLabels.length === 0) {
        return items;
    }
    return (0, ramda_1.uniq)(attributeLabels).reduce((acc, label) => (0, exports.removeAttributeValues)(acc, label), items);
};
exports.removeAttributeValuesMany = removeAttributeValuesMany;
